<template>
  <ButtonCommon
    :block="block"
    :disabled="bookingLoading"
    :jumbo="jumbo"
    :type="submitButtonType"
    class="button--book-appointment"
    variant="success"
    @click="submitRequest">
    {{submitButtonLabel}}
  </ButtonCommon>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import ButtonCommon from '@/components/common/ButtonCommon.vue';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    ButtonCommon,
  },
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    jumbo: {
      type: Boolean,
      default: false,
    },
    submitMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitError: null,
    };
  },
  computed: {
    ...mapState('Appointment', ['bookingLoading']),
    ...mapGetters('Company', [
      'getCompany',
      'blockAppointmentsEnabled',
    ]),
    submitButtonLabel() {
      if (this.blockAppointmentsEnabled) {
        return this.bookingLoading
          ? 'Booking Your Appointment'
          : 'Book Appointment';
      }
      return this.bookingLoading
        ? 'Requesting Your Appointment'
        : 'Request Appointment';
    },
    submitButtonType() {
      return this.submitMode ? 'submit' : 'button';
    },
  },
  methods: {
    async submitRequest() {
      try {
        this.submitError = null;
        await this.$store.commit('Appointment/clearErrors');
        const scheduledAppointment = await this.$store.dispatch(
          'Appointment/saveRequest',
          this.getCompany.id,
        );
        this.$store.commit('Schedule/resetState');

        StepUtilities.goToConfirmationStep(scheduledAppointment.id, this.$router);
      } catch (err) {
        this.submitError = err;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/mixins/breakpoints';
@import '../styles/vars/theme';

.book-button {
  background-color: $theme-color-success;
  color: $theme-color-black;
  height: 50px;
  margin-top: 10px;
  padding-left: 28px;
  padding-right: 28px;
  position: relative;
  width: 100%;
}

@include responsive-breakpoint(sm) {
  .book-button {
    margin: 0;
  }
}
</style>
